'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_math_Ordering$String$() {
}
export { $c_s_math_Ordering$String$ as $c_s_math_Ordering$String$ };
$p = $c_s_math_Ordering$String$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_math_Ordering$String$;
/** @constructor */
function $h_s_math_Ordering$String$() {
}
export { $h_s_math_Ordering$String$ as $h_s_math_Ordering$String$ };
$h_s_math_Ordering$String$.prototype = $p;
$p.hl = (function(other) {
  return $j_java$002elang$002e$002dObject.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.bq = (function(x, y) {
  return $j_java$002elang$002e$002dObject.$f_T__compareTo__T__I(x, y);
});
var $d_s_math_Ordering$String$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_math_Ordering$String$, "scala.math.Ordering$String$", ({
  v5: 1,
  a7: 1,
  a: 1,
  aJ: 1,
  aM: 1,
  aL: 1,
  v6: 1
}));
export { $d_s_math_Ordering$String$ as $d_s_math_Ordering$String$ };
var $n_s_math_Ordering$String$;
function $m_s_math_Ordering$String$() {
  if ((!$n_s_math_Ordering$String$)) {
    $n_s_math_Ordering$String$ = new $c_s_math_Ordering$String$();
  }
  return $n_s_math_Ordering$String$;
}
export { $m_s_math_Ordering$String$ as $m_s_math_Ordering$String$ };
